<div class="inicio p-8">
  <header class="mb-10">
    <h1 class="text-3xl font-bold text-chathams-blue">
      Olá, {{ session.name }}
    </h1>
    <p class="text-lg text-alto-700 mt-1">
      Perfil: <span class="font-semibold text-chathams-blue">{{ session.role }}</span>
    </p>
  </header>

  <section>
    <h2 class="text-sm font-semibold uppercase tracking-wide text-alto-700 mb-4">
      Continuar de onde parou
    </h2>

    <div
      *ngIf="atalhos.length; else estadoVazio"
      class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4"
    >
      <ng-container *ngFor="let atalho of atalhos">
        <a
          *isAllowed="atalho.permissions"
          class="atalho-card"
          [routerLink]="'/dash/' + atalho.route"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Ir para ' + atalho.label"
        >
          <lucide-icon [name]="atalho.icon" [size]="28" class="text-chathams-blue"></lucide-icon>
          <span class="atalho-card__label">{{ atalho.label }}</span>
        </a>
      </ng-container>
    </div>

    <ng-template #estadoVazio>
      <div class="flex flex-col items-center justify-center text-center py-16 text-alto-700">
        <lucide-icon name="compass" [size]="40" class="mb-3 text-alto-600"></lucide-icon>
        <p class="text-base">Você ainda não visitou nenhuma página.</p>
        <p class="text-sm">Explore o menu lateral para começar.</p>
      </div>
    </ng-template>
  </section>
</div>
